const isDevelopment = process.env.NODE_ENV !== 'production';

export const logger = {
  debug: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log('[DEBUG]', ...args);
    }
  },
  info: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.info('[INFO]', ...args);
    }
  },
  warn: (...args) => {
    // eslint-disable-next-line no-console
    console.warn('[WARN]', ...args);
  },
  error: (...args) => {
    // Always log errors
    // eslint-disable-next-line no-console
    console.error('[ERROR]', ...args);

    // Optional: Send to error tracking service in production
    // Uncomment and configure when Sentry or similar is added
    // if (!isDevelopment && window.Sentry) {
    //   window.Sentry.captureException(args[0]);
    // }
  },
};

export default logger;
